"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
//@ts-ignore
var classnames_1 = tslib_1.__importDefault(require("classnames"));
function extendStyles(sourceStyles, partialStyles) {
    var styles = tslib_1.__assign({}, sourceStyles);
    Object.keys(partialStyles).forEach(function (styleName) {
        styles[styleName] = styles[styleName]
            ? classnames_1.default(styles[styleName], partialStyles[styleName])
            : partialStyles[styleName];
    });
    return styles;
}
exports.default = extendStyles;
//# sourceMappingURL=extendStyles.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/playable/dist/src/modules/ui/core/extendStyles.js
// module id = 59
// module chunks = 0